import { render } from "./RoundsTable.vue?vue&type=template&id=28f8f2b0&scoped=true"
import script from "./RoundsTable.vue?vue&type=script&lang=js"
export * from "./RoundsTable.vue?vue&type=script&lang=js"

import "./RoundsTable.vue?vue&type=style&index=0&id=28f8f2b0&scoped=true&lang=scss"

import exportComponent from "/var/www/driveapp2.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f8f2b0"]])

export default __exports__